import { makePlaqueQuitToggle } from "/plaque/quit_plaque_toggle.js";

const mainBodyElement = document.querySelector('body');

export function createPlaque() {
    const plaque = document.createElement('div');
    plaque.setAttribute('id', 'plaque');
    mainBodyElement.append(plaque);
    //plaque.addEventListener('click', e => plaquePress(e));

    plaque.makePlaqueQuitToggle = (message, messageCancel, messageConfirm) => makePlaqueQuitToggle(plaque, message, messageCancel, messageConfirm);


    return plaque;
}

export function createPlaqueWithQuickExit() {
    const plaque = createPlaque();
    plaque.addEventListener('click', e => plaquePress(e));

    return plaque;
}


function plaquePress(e) {
    if(e.target.id==='plaque')
        document.getElementById('plaque').remove();
}